module.exports = __webpack_public_path__ + "img/0050.a50c75b2.jpg";